import React, { useState } from 'react';
import { Card, Breadcrumb, Input, Row, Col, List, Space, Button, Spin } from 'antd';
import Background from '../../../../static/img/bg-list-title.png';
import { queryOpenAPIDeveloperList } from './gqls'
import Client from '../../../../lib/gqlClient';
import { useNavigate ,useLocation} from 'react-router-dom';
import { Link } from 'react-router-dom';
const DeveloperList = (props) => {
    const navigate = useNavigate();
    const location = useLocation()
    const { state } = location
    const [page, setPage] = useState(1)
    const [showSize, setShowSize] = useState(8)
    const [seatchData, setSeatchData] = useState('')
    const [isGetData, setIsGetData] = useState(false)
    const [total, setTotal] = useState(1)
    const [dataList, setDataList] = useState([])
    React.useEffect(() => {
        if (state != null) {
            setSeatchData(state.seatchData)
            setPage(state.page)
            setShowSize(state.showSize)
            getOpenAPIDeveloperList(state.seatchData, state.page, state.showSize)
        }else{
            onSearch()
        }
    }, [])
    function onInPut(value) {
        console.log(value.target.value);
        setSeatchData(value.target.value)
    }
    function onSearch() {
        getOpenAPIDeveloperList(seatchData, page, showSize)
    }
    function getOpenAPIDeveloperList(value, page, count) {
        setIsGetData(true)
        if (count !== showSize) {
            setShowSize(count)
        }
        Client(
            queryOpenAPIDeveloperList,
            {
                page: page,
                count: count,
                email: value,
            }
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                setDataList(res.data.openAPIDeveloperList.data)
                setTotal(res.data.openAPIDeveloperList.total)
            }
            setIsGetData(false)
        }).catch(e => {
            // console.log(e);
            setIsGetData(false)
        })
    }

    function onClick(id) {
        navigate('/developerCenter/developer/appTrend', {
            replace: false,
            state: {
                appUserId: id,
                page: page,
                showSize: showSize
            }
        })
    }
    function onStart() {
        props.setNewKey('developerCenter/apiDataNoticfication')
        navigate('/developerCenter/apiDataNoticfication')

    }
    return (
        <div style={{ height: '100%', width: '100%', }}>

            {/* 标题头 */}
            <div style={{ height: '200px', padding: '0px', backgroundColor: 'white', borderRadius: '2px' }}>
                <Breadcrumb style={{ marginLeft: '20px', paddingTop: "6px" }}>
                    <Breadcrumb.Item><Link to='../../../home' style={{ fontSize: '12px' }}>首页</Link></Breadcrumb.Item>
                    <Breadcrumb.Item><a onClick={onStart} style={{ fontSize: '12px' }}>API Dashboard</a></Breadcrumb.Item>
                    <Breadcrumb.Item><a style={{ fontSize: '12px' }}>开发者列表</a></Breadcrumb.Item>
                </Breadcrumb>
                <div style={Styles.title}>搜索开发者</div>

                <Row style={Styles.search}>
                    <Col>
                        <div >
                            <Input
                                placeholder="请输入 Client (Developer email address)"
                                size="large"
                                style={{
                                    width: '556px',
                                    borderRadius: '2px',
                                    height: '46px'
                                }}
                                onChange={onInPut}
                                onPressEnter={onSearch}
                            />
                        </div></Col>
                    <Col>
                        <Button style={{ padding: '0px', height: '46px', width: '80px', background: '#FF5300', color: 'white' }} onClick={onSearch}>搜索</Button>
                    </Col>
                </Row>

            </div>


            <Card bordered={false} style={{ marginTop: '25px', marginBottom: '25px', padding: '0px', }}>
                <div style={Styles.listTitle}>开发者列表</div>
                <Row style={Styles.listTitleBg}>
                    <Col span={6} style={Styles.listTitleText}>
                        Client
                    </Col>
                    <Col span={6} style={Styles.listTitleText}>
                        <div style={{ display: 'flex', marginLeft: '30px', alignItems: 'center', }}>Organization</div>
                    </Col>
                    <Col span={4} style={Styles.listTitleText}>
                        <div style={{ display: 'flex', marginLeft: '30px', alignItems: 'center', }}>Create Time</div>
                    </Col>
                    <Col span={4} style={Styles.listTitleText}>
                        <div style={{ display: 'flex', marginLeft: '30px', alignItems: 'center', }}> Last Change Time</div>
                    </Col>
                    <Col span={4} style={{ fontSize: '14px', lineHeight: '22px', display: 'flex', justifyContent: 'right', alignItems: 'center', }}>
                        Operation
                    </Col>
                </Row>
                <Spin size="large" tip="Loading..." spinning={isGetData}>

                    <List
                        itemLayout="vertical"
                        split="true"
                        pagination={{
                            onChange: (page, pageSize) => {
                                console.log(page);
                                setPage(page)
                                getOpenAPIDeveloperList(seatchData, page, pageSize)
                            },
                            pageSize: showSize,
                            hideOnSinglePage: true,
                            pageSizeOptions: [8, 10, 15, 20, 30, 50, 80, 100],
                            current: page,
                            total: total

                        }}
                        position="bottom"
                        dataSource={dataList}
                        renderItem={(item) => (
                            <List.Item >
                                <Row style={Styles.item}>
                                    <Col span={6} style={Styles.listTitleText}>
                                        <div style={{ display: 'flex', marginLeft: '60px', alignItems: 'center', }}> {item.client}</div>
                                    </Col>
                                    <Col span={6} style={Styles.listTitleText}>
                                        <div style={{ display: 'flex', marginLeft: '60px', alignItems: 'center', }}>{item.organization}</div>
                                    </Col>
                                    <Col span={4} style={Styles.listTitleText}>
                                        <div style={{ display: 'flex', marginLeft: '30px', alignItems: 'center', }}>{item.createTime}</div>
                                    </Col>
                                    <Col span={4} style={Styles.listTitleText}>
                                        <div style={{ display: 'flex', marginLeft: '30px', alignItems: 'center', }}>{item.lastChangeTime}</div>
                                    </Col>
                                    <Col span={4} style={{ fontSize: '14px', lineHeight: '22px', display: 'flex', justifyContent: 'right', alignItems: 'center', paddingRight: '70px' }}>
                                        <a onClick={() => onClick(item.appUserId)}>
                                            <Space style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', color: '#2657F9' }}>
                                                App List
                                            </Space>
                                        </a>
                                    </Col>
                                </Row>
                            </List.Item>
                        )}
                    />
                </Spin>
            </Card>

        </div>
    );

}

const { Search } = Input;
const Styles = {
    title: {
        display: 'block',
        fontSize: '20px',
        color: '#000000',
        marginLeft: '150px',
        marginTop: '30px'
    },
    search: {
        color: '#2D3238',
        height: '46px',
        marginTop: '30px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    listTitle: {
        display: 'block',
        fontSize: '16px',
        color: '#000000',
        marginTop: '25px',
        textAlign: 'center'

    },
    listTitleBg: {
        height: '54px',
        backgroundImage: `url(${Background})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%, 100%',
        marginTop: '30px',
        paddingLeft: '60px',
        paddingRight: '60px'
    },
    listTitleText: {
        fontSize: '14px',
        lineHeight: '22px',
        display: 'flex',
        alignItems: 'center',
    },
    listTitleCenterText: {
        fontSize: '14px',
        lineHeight: '22px',
        marginTop: '16px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    item: {
        height: '84px',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%, 100%',
    },
}
export default DeveloperList